export default {
    'AVICON_DIAMOND'     : 'fa fa-diamond',
    'AVICON_JOB'         : 'fa fa-briefcase',
    'AVICON_CALENDAR'    : 'icon-calendar',
    'AVICON_MAINTENANCE' : 'icon-puzzle',
    'AVICON_BOOKING'     : 'icon-event',
    'AVICON_HOURGLASS'   : 'fa fa-hourglass-end',
    'AVICON_ASC'         : 'icon-sort fa fa-sort-alpha-asc',
    'AVICON_DESC'        : 'icon-sort fa fa-sort-alpha-desc',
    'AVICON_QR'			 		 : 'fa fa-qrcode',
    'AVICON_BILLING'		 : 'fa fa-credit-card-alt ',

}



// WEBPACK FOOTER //
// ./src/App/utils/IconMaping.js